// Or if you want a reusable enum:
export enum AccountTypeEnum {
	Procurer = 1,
	Bidder = 2,
	Bidder_Procurer = 3,
	Sponsored_Bidder = 8,
}
